import React from "react";
import { CgLogIn } from 'react-icons/cg';
import Multiselect from 'multiselect-react-dropdown';


// 
export default function AddLeadModal(props) {


  let { addLeadModal, handleAddLeadModalClose, multiselectRef, multiselectRefUser, errorsLead, inputAddUserChange, createLeadSubmit, fieldsLead, getAllUser,
    // options,
    selectedValue, onSelect, onRemove, getAllCategory, onUserSelect, onUserRemove, handleMobileNumber, handlePaste
    // handleSelectedTag, selectedTag
  } = props;

  let categoryData = [];
  if (getAllCategory && getAllCategory.length > 0) {
    getAllCategory.forEach((event) => {
      categoryData.push(
        {
          name: event.name,
          id: event.id,
        }
      )
    })
  }

  let userData = [];
  if (getAllUser && getAllUser.length > 0) {
    getAllUser.forEach((event) => {
      userData.push(
        {
          userName: event.userName,
          email: event.email,
          id: event._id,
        }
      )
    })
  }
  console.log('userData____MODAL______________', userData);

  return (

    <div className={addLeadModal ? "fixed w-full lg:left-24 left-0 h-full inset-0 z-40 overflow-hidden mt-0 flex justify-center items-center overflow-y-auto bg-black/40 md:p-0 p-1" : "hidden"} style={{ marginTop: '0rem', }}  >
      <div className="animate__animated animate__fadeInDown animate__faster bg-[#f8f8fb] md:w-[38rem] w-full mx-auto rounded shadow-lg overflow-y-auto mt-2">
        {/*modal header*/}
        <div className="flex items-center justify-between p-6 py-2 bg-blue-500 border-b">
          <p className="text-[16px] lg:px-0 px-12 font-medium text-white uppercase">Add Lead</p>
          <div className="rounded-full cursor-pointer modal-close ">
            <svg onClick={() => handleAddLeadModalClose()} className="fill-current text-white/60 hover:text-white/100" xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 18 18">
              <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z">
              </path>
            </svg>
          </div>
        </div>

        <div className="p-4">
          <button className="text-sm text-gray-600 font-medium p-4 py-2 border border-gray-300 border-b-transparent bg-white -mb-0.5">
            Create Lead
          </button>
          <form autoComplete="off" className="p-4 space-y-4 capitalize border border-gray-300 ">

            <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">

              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="username">Name :</label>
                <input className={`w-full p-2 mt-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500   ${errorsLead && !errorsLead["name"] ? "border  placeholder-gray-500" : "border border-red-500 "}`}
                  id="name" name="name" placeholder="Name..." type="text" value={fieldsLead && fieldsLead.name ? fieldsLead.name : ""} onChange={inputAddUserChange} />
                {errorsLead && errorsLead["name"] ?
                  <div className="text-xs text-red-500 invalid-feedback">
                    {errorsLead["name"]}
                  </div>
                  : null}
              </div>
              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="username">Date :</label>
                <input className={`w-full p-2 mt-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500   ${errorsLead && !errorsLead["name"] ? "border  placeholder-gray-500" : "border border-red-500 "}`}
                  id="calenderDate" name="calenderDate" placeholder="calenderDate..." type="date" value={fieldsLead && fieldsLead.calenderDate ? fieldsLead.calenderDate : ""}
                  onChange={inputAddUserChange}
                />
                {errorsLead && errorsLead["calenderDate"] ?
                  <div className="text-xs text-red-500 invalid-feedback">
                    {errorsLead["calenderDate"]}
                  </div>
                  : null}
              </div>

              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="username">Mobile No :</label>
                <input className={`w-full p-2 mt-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500   ${errorsLead && !errorsLead["mobNo"] ? "border  placeholder-gray-500" : "border border-red-500 "}`}
                  id="mobNo" name="mobNo" placeholder="Mobile No..." type="text" value={fieldsLead && fieldsLead.mobNo ? fieldsLead.mobNo : ""}
                  onChange={handleMobileNumber}
                // onPaste={handlePaste}
                />
                {errorsLead && errorsLead["mobNo"] ?
                  <div className="text-xs text-red-500 invalid-feedback">
                    {errorsLead["mobNo"]}
                  </div>
                  : null}
              </div>

              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="username">Email :</label>
                <input className={`w-full p-2 mt-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500   ${errorsLead && !errorsLead["email"] ? "border  placeholder-gray-500" : "border border-red-500 "}`}
                  id="email" name="email" placeholder="Email..." type="email" value={fieldsLead && fieldsLead.email ? fieldsLead.email : ""} onChange={inputAddUserChange} />
                {errorsLead && errorsLead["email"] ?
                  <div className="text-xs text-red-500 invalid-feedback">
                    {errorsLead["email"]}
                  </div>
                  : null}
              </div>
              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="username">Requirement :</label>
                <textarea className={` w-full p-2 mt-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500  ${errorsLead && !errorsLead["requirement"] ? "border  placeholder-gray-500" : "border border-red-500 "}`}
                  id="requirement" name="requirement" placeholder="Requirement..." type="text" value={fieldsLead && fieldsLead.requirement ? fieldsLead.requirement : ""} onChange={inputAddUserChange} />
                {errorsLead && errorsLead["requirement"] ?
                  <div className="text-xs text-red-500 invalid-feedback">
                    {errorsLead["requirement"]}
                  </div>
                  : null}
              </div>

              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="username"> Select Category :</label>
                {JSON.stringify(selectedValue)}
                <Multiselect
                  ref={multiselectRef}
                  options={categoryData} // Options to display in the dropdown
                  selectedValues={selectedValue} // Preselected value to persist in dropdown
                  onSelect={onSelect} // Function will trigger on select event
                  onRemove={onRemove} // Function will trigger on remove event
                  displayValue="name" // Property name to display in the dropdown options
                />
              </div>

              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="username">Select Assignee Users :</label>
                <Multiselect
                  ref={multiselectRefUser}
                  options={userData} // Options to display in the dropdown
                  selectedValues={selectedValue} // Preselected value to persist in dropdown
                  onSelect={onUserSelect} // Function will trigger on select event
                  onRemove={onUserRemove} // Function will trigger on remove event
                  displayValue="userName" // Property name to display in the dropdown options
                />
              </div>
              {/* <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="source">Source :</label>
                <input className={`w-full p-2 mt-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500   ${errorsLead && !errorsLead["source"] ? "border  placeholder-gray-500" : "border border-red-500 "}`}
                  id="source" name="source" placeholder="Source..." type="text" value={fieldsLead && fieldsLead.source ? fieldsLead.source : ""} onChange={inputAddUserChange} />
                {errorsLead && errorsLead["source"] ?
                  <div className="text-xs text-red-500 invalid-feedback">
                    {errorsLead["source"]}
                  </div>
                  : null}
              </div> */}
              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="Location">location :</label>
                <input className={`w-full p-2 mt-1 text-sm  border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500  border  placeholder-gray-500   "}`}
                  id="location" name="location" placeholder="Location..." type="text" value={fieldsLead && fieldsLead.location ? fieldsLead.location : ""} onChange={inputAddUserChange} />
                {/* {errorsLead && errorsLead["location"] ?
                  <div className="text-xs text-red-500 invalid-feedback">
                    {errorsLead["location"]}
                  </div>
                  : null} */}
              </div>
              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="companyName">Company Name :</label>
                <input className={`w-full p-2 mt-1 text-sm  border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500  border  placeholder-gray-500   "}`}
                  id="companyName" name="companyName" placeholder="Company Name..." type="text" value={fieldsLead && fieldsLead.companyName ? fieldsLead.companyName : ""} onChange={inputAddUserChange} />
              </div>
            </div>
            <div className="flex justify-end py-0 space-x-4">
              <button className="bg-blue-500 transition duration-150 text-white text-[.8125rem]  px-3 py-2 rounded-[.25rem] flex items-center hover:bg-[#f14646] " type="button"
                onClick={() => createLeadSubmit()}>Submit
                <CgLogIn size={18} className="ml-2" />
              </button>
            </div>
          </form>
        </div>
        {/*Footer*/}
      </div>
    </div>
  );
}
